import { usePortfolio } from "@/contexts/PortfolioContext";
import { useEntitlements } from "@/hooks/useEntitlements";

/**
 * Paid access for a feature that runs on the selected portfolio.
 *
 * The demo unlocks paid portfolio features for everyone, so a free user can try them on fake
 * data. The "All portfolios" rollup stays locked even when it holds the demo, because it also
 * holds the user's real portfolios. The backend applies the same rule
 * (`entitlements.has_paid_access_for_portfolio`).
 */
export function usePortfolioPaidAccess() {
  const { isPaid, isLoading: isEntitlementsLoading } = useEntitlements();
  const { selectedPortfolio, isLoading: isPortfoliosLoading } = usePortfolio();

  const isDemo = !!selectedPortfolio?.is_demo;

  return {
    canUse: isPaid || isDemo,
    /** A free user trying a paid feature on the demo. */
    isDemoPreview: !isPaid && isDemo,
    // Paying users never wait on the portfolio list, since it cannot change their answer.
    isLoading: isEntitlementsLoading || (!isPaid && isPortfoliosLoading),
  };
}
